export class Customer {
  public static AIRBUSDS: string = "airbusds";
  public static AMLAS: string = "amlas";
  public static ATLAS: string = "atlas";
  public static AUTOFLUG: string = "autoflug";
  public static BELIMO: string = "belimo";
  public static BVG: string = "bvg";
  public static CAE: string = "cae";
  public static CEOTRONICS: string = "ceotronics";
  public static COOP: string = "coop";
  public static DB: string = "db";
  public static DEMO: string = "demo";
  public static DEMOZ2DATA: string = "demoz2data";
  public static DIEHL: string = "diehl";
  public static EBERSPACHER: string = "eberspacher";
  public static EMZ: string = "emz";
  public static HAGENUK: string = "hagenuk";
  public static HERRMANNULTRASCHALL: string = "herrmannultraschall";
  public static IAV: string = "iav";
  public static KARLSTORZ: string = "karlstorz";
  public static KNDS: string = "knds";
  public static KOMAX: string = "komax";
  public static KVB: string = "kvb";
  public static LEONARDO: string = "leonardo";
  public static LRE: string = "lre";
  public static LUTRON: string = "lutron";
  public static MAQUETGMBH: string = "maquetgmbh";
  public static MRCE: string = "mrce";
  public static MTU: string = "mtu";
  public static NS: string = "ns";
  public static OC: string = "oc";
  public static OMC: string = "omc";
  public static OMP: string = "omp";
  public static ONESUBSEA: string = "onesubsea";
  public static PILZ: string = "pilz";
  public static PLASTICOMNIUM: string = "plasticomnium";
  public static PLATH: string = "plath";
  public static RADWELL: string = "radwell";
  public static RHEINBAHN: string = "rheinbahn";
  public static RHEINMETALL: string = "rheinmetall";
  public static RHEINMETALLAIRDEFENCE: string = "rheinmetallairdefence";
  public static RHEINMETALLITALY: string = "rheinmetallitaly";
  public static RME: string = "rme";
  public static RMMVO: string = "rmmvo";
  public static ROSEN: string = "rosen";
  public static RUAGCH: string = "ruagch";
  public static RWM: string = "rwm";
  public static SCHIEBEL: string = "schiebel";
  public static SEW: string = "sew";
  public static STADLER: string = "stadler";
  public static TAE: string = "tae";
  public static TAL: string = "tal";
  public static THALES: string = "thales";
  public static TRIAL1: string = "trial1";
  public static TRIAL2: string = "trial2";
  public static TRIAL3: string = "trial3";
  public static TRIAL4: string = "trial4";
  public static TTI: string = "tti";
  public static VANDERLANDE: string = "vanderlande";
  public static VIASTORE: string = "viastore";
  public static XLIVE: string = "xlive";
  public static EXAMPLE: string = "example";
}
